import React from "react";
import {Route} from "react-router-dom";
import { Translate } from "react-localize-redux";
import {Container, Row, Col, NavbarBrand, Navbar} from "reactstrap";
import AuthFooter from "../Footers/AuthFooter.js";
import "./layout.css";
import * as navFunc from "../Navbars/navFunc"
import {connect} from "react-redux";
import LanguageToggle from "../language/languageToggle";


class Auth extends React.Component {
  componentDidMount() {
    document.body.classList.add("bg-default");
  }
  componentWillUnmount() {
    document.body.classList.remove("bg-default");
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
            <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  onBankLogoClick = () => {
    let bankUrl = navFunc.bankUrl(localStorage.getItem('bank'));
    // window.location.replace(bankUrl)
    window.open(bankUrl, "_blank")

  }

  render() {
    return (
      <>
        <div className="main-content">
          <Navbar
              className="navbar-top navbar-horizontal navbar-dark"
              expand="md"
              id="navbar-main"
          >
            <Container className="px-4">

              <NavbarBrand to="#">
                <img onClick={this.onBankLogoClick} alt="..." src={require("../../assets/img/brand/" + navFunc.bankLogo(localStorage.getItem('bank')) + ".png")} />
              </NavbarBrand>

              <LanguageToggle />
            </Container>
          </Navbar>
          <div className={navFunc.bankColors(localStorage.getItem('bank'))} >
            <Container className="mt--2" >
              <div className="header-body text-center mb-7">
                <Row className="justify-content-center">
                  <Col lg="5" md="6">
                    <h1 className="text-white">
                      <Translate id="login.title" data={{ mark: "!" }} />
                    </h1>
                    <p className="text-lead text-light">
                      <Translate id="login.sub.title"/>
                    </p>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-default"
                  points="2560 0 2560 700 0 100"
                />
              </svg>
            </div>
          </div>
          {/* Page content */}
          <Container className="mt--6 pb-5">
            <Row className="justify-content-center">
              {this.props.children}
            </Row>
          </Container>
        </div>
        <AuthFooter />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    bankId: state.authNavbar.bankId
  }
}
const mapDispatchToProps = dispatch => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
